import styled from '@emotion/styled';

import { OptionElementProps } from './types';

export const OptionElement = styled.div<OptionElementProps>`
  background: ${({ theme }) => theme.background.normal};

  &:hover {
    background: ${({ theme }) => theme.background.hover};
    color: ${({ theme }) => theme.color.hover};
  }

  /* focus state */
  ${({ is_focused, theme }) =>
    is_focused &&
    `
     background: ${theme.background.focus};
   `}

  /* active state */
 ${({ is_selected, theme }) =>
    is_selected &&
    `
     background: ${theme.background.active};
     color: ${theme.color.active};
   `}
`;
